export default "__VITE_ASSET__QIGBSZMw__"